import { trackKlaviyo } from '../../utils/dom';
import { generateEventId, applyVAT, urlify, stringIntersection } from '../../utils/string';
import { prefix } from '../../utils/locale';

const viewAnalytics = (price, product, cachedProduct, setup, currentPath, fromList = {}) => {
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	const itemCategory = currentPath.split('/').slice(0, -1).reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});
	const uniqueEventID = generateEventId();
	const sku = stringIntersection((cachedProduct.sizes || []).map((s) => s.sku));

	window.dataLayer.push({ values: null });
	window.dataLayer.push({
		event: 'ViewContent',
		event_id: uniqueEventID,
		values: {
			value: applyVAT(setup, price),
			currency: setup.currency,
			content_name: product.title,
			content_type: 'product_group',
			content_ids: [cachedProduct.variantId],
		},
	});

	window.dataLayer.push({ ecommerce: null });
	const pVariants = !Array.isArray(product.variants) ? Object.keys(product.variants).map((k) => product.variants[k]) : product.variants;
	window.dataLayer.push({
		event: 'ViewContentGA',
		ecommerce: {
			detail: {
				actionField: { list: fromList[cachedProduct.variantId] || '' },
				products: [{
					name: product.title,
					id: cachedProduct.variantId,
					sku,
					price: applyVAT(setup, price),
					brand: product.vendor,
					category: currentPath.slice(0, currentPath.lastIndexOf('/')),
					variant: pVariants.filter((v) => v.selectedOptions?.color).reduce((acc, v) => (!acc ? v.selectedOptions.color : acc), ''),
				}],
			},
		},
	});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'view_item',
		ecommerce: {
			'x-fb-event_id': uniqueEventID,
			currency: setup.currency,
			items: [{
				item_name: product.title,
				item_id: cachedProduct.variantId,
				price: applyVAT(setup, price),
				currency: setup.currency,
				item_brand: product.vendor,
				...itemCategory,
				item_list_id: urlify(fromList[cachedProduct.variantId] || ''),
				item_list_name: fromList[cachedProduct.variantId] || '',
				quantity: '1',
			}],
		},
	});

	const viewedProduct = {
		ProductName: cachedProduct.name,
		ProductID: cachedProduct.id,
		SKU: stringIntersection((cachedProduct.sizes || []).map((s) => s.sku)),
		Categories: cachedProduct.canonicalUri.split('/').slice(0, -1),
		ImageURL: cachedProduct.media?.[0]?.src || '',
		URL: `${window.location.origin}${prefix(setup, cachedProduct.canonicalUri)}`,
		Brand: product.vendor,
		Currency: setup.currency,
		Price: applyVAT(setup, cachedProduct.price),
		CompareAtPrice: applyVAT(setup, (cachedProduct.comparePrice || cachedProduct.price)),
	};

	const trackViewedItem = {
		Title: cachedProduct.name,
		ItemId: cachedProduct.id,
		Categories: cachedProduct.canonicalUri.split('/').slice(0, -1),
		ImageUrl: cachedProduct.media?.[0]?.src || '',
		Url: `${window.location.origin}${prefix(setup, cachedProduct.canonicalUri)}`,
		Metadata: {
			Brand: product.vendor,
			Currency: setup.currency,
			Price: applyVAT(setup, cachedProduct.price),
			CompareAtPrice: applyVAT(setup, (cachedProduct.comparePrice || cachedProduct.price)),
		},
	};

	trackKlaviyo((kl) => {
		kl.track('Viewed Product', viewedProduct);
		kl.trackViewedItem(trackViewedItem);
	});
};

export default viewAnalytics;
